export default __webpack_public_path__ + "static/media/SteamBridgeMap.13298f94.jpg";